/*
 * PANORAMA 360 — « Mon compte » (sections/p360-compte.liquid) et favoris (états maquette, compte seul et programme en ligne).
 * - onglets du compte (Accueil, Commandes, Pano Points, Favoris, La lettre, Mes infos), lien direct par #onglet
 * - cœur « favoris » sur les cartes produit du thème et sur la fiche produit, liste des favoris dans le compte
 * - pièces « vues récemment »
 * - préférences de « Mes infos » (anniversaire, notifications)
 * Maquette : favoris, « vues récemment » et préférences sont gardés sur l'appareil (localStorage).
 * En production : favoris et préférences dans des métachamps client, pour les retrouver sur tous les appareils.
 * Fonctionne avec p360.js (profils de démo, jeu du jour), sans le modifier.
 */
(function () {
  if (window.__p360CompteReady) return;
  window.__p360CompteReady = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var toastTimer = null;

  function toast(message) {
    var t = document.querySelector('.p360-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'p360-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.textContent = message;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      t.classList.remove('is-visible');
    }, 3600);
  }

  function fmt(n) {
    return Math.round(n).toLocaleString('fr-FR');
  }

  function store(key, value) {
    try {
      if (value === null) localStorage.removeItem(key);
      else localStorage.setItem(key, value);
    } catch (e) {}
  }

  function load(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  // Jeu du jour d'un onglet qui vient de s'afficher (fonction fournie par p360.js)
  function initGames(scope) {
    if (typeof window.p360Refresh === 'function') window.p360Refresh(scope);
  }

  var TABS = ['accueil', 'commandes', 'points', 'favoris', 'lettre', 'infos'];
  var FAV_KEY = 'p360-favs';
  var SEEN_KEY = 'p360-seen';
  var HEART =
    '<svg class="p360-heart__svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 20.2s-7.6-4.6-7.6-10.1A4.3 4.3 0 0112 7.4a4.3 4.3 0 017.6 2.7c0 5.5-7.6 10.1-7.6 10.1z"/></svg>';

  function readList(key) {
    try {
      var v = JSON.parse(load(key) || '[]');
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string' && /^[a-z0-9-]+$/.test(h); }) : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(key, list) {
    store(key, JSON.stringify(list.slice(0, 60)));
  }

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function money(cents) {
    var n = (cents || 0) / 100;
    return (Number.isInteger(n) ? fmt(n) : n.toFixed(2).replace('.', ',')) + ' €';
  }

  // Fiche produit en JSON ; on réessaie deux fois si Shopify répond « occupé » (503), pas si la pièce n'existe plus (404)
  var productCache = {};
  function getProduct(handle) {
    if (!productCache[handle]) {
      var tries = 0;
      var go = function () {
        return fetch(shopRoot() + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) {
            if (r.ok) return r.json();
            if (r.status === 404) return null;
            throw new Error(String(r.status));
          })
          .catch(function () {
            tries++;
            if (tries < 3) {
              return new Promise(function (resolve) {
                setTimeout(resolve, 700 * tries);
              }).then(go);
            }
            delete productCache[handle];
            return null;
          });
      };
      productCache[handle] = go();
    }
    return productCache[handle];
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }

  // Même gabarit que snippets/p360-fav-card.liquid
  function favCard(p, local) {
    var sold = !p.available;
    var card = el('article', 'p360-fav' + (sold ? ' is-sold' : ''));
    if (local) card.setAttribute('data-local', p.handle);
    var media = el('a', 'p360-fav__media');
    media.href = p.url;
    media.tabIndex = -1;
    media.setAttribute('aria-hidden', 'true');
    if (p.featured_image) {
      var img = el('img');
      var src = p.featured_image;
      img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=500';
      img.alt = '';
      img.loading = 'lazy';
      media.appendChild(img);
    }
    if (sold) media.appendChild(el('span', 'p360-fav__sold', 'Vendue'));
    var heart = el('button', 'p360-heart');
    heart.type = 'button';
    heart.setAttribute('data-p360-fav', p.handle);
    heart.setAttribute('aria-pressed', readList(FAV_KEY).indexOf(p.handle) > -1 ? 'true' : 'false');
    heart.setAttribute('aria-label', 'Garder ' + p.title + ' dans mes favoris');
    heart.innerHTML = HEART;
    var title = el('a', 'p360-fav__title', p.title);
    title.href = p.url;
    var price = el('p', 'p360-fav__price', sold ? 'Vendue' : money(p.price));
    card.appendChild(media);
    card.appendChild(heart);
    card.appendChild(title);
    card.appendChild(price);
    return card;
  }

  function syncHearts() {
    var favs = readList(FAV_KEY);
    document.querySelectorAll('[data-p360-fav]').forEach(function (b) {
      b.setAttribute('aria-pressed', favs.indexOf(b.getAttribute('data-p360-fav')) > -1 ? 'true' : 'false');
    });
  }

  function renderFavs() {
    var boxes = document.querySelectorAll('[data-p360-favs]');
    if (!boxes.length) return;
    var favs = readList(FAV_KEY);
    Promise.all(favs.map(getProduct)).then(function (list) {
      var items = list.filter(Boolean);
      var soldLocal = items.filter(function (p) { return !p.available; }).length;
      boxes.forEach(function (box) {
        box.querySelectorAll('[data-local]').forEach(function (n) { n.remove(); });
        var first = box.firstChild;
        items.forEach(function (p) {
          box.insertBefore(favCard(p, true), first);
        });
        // Le compte (ou, pour un visiteur, la carte de connexion) qui contient cette liste
        var hub = box.closest('[data-p360-tabs]') || box.closest('.p360-signin') || document;
        var counter = hub.querySelector('[data-p360-fav-count]');
        var total = (counter ? parseInt(counter.getAttribute('data-base'), 10) || 0 : 0) + items.length;
        hub.querySelectorAll('[data-p360-fav-count]').forEach(function (c) {
          c.textContent = total;
          if (c.classList.contains('p360-tabs__count')) c.hidden = total === 0;
        });
        var empty = hub.querySelector('[data-p360-favs-empty]');
        if (empty) empty.hidden = total > 0;
        var sub = hub.querySelector('[data-p360-fav-sub]');
        if (sub) {
          var sold = (parseInt(sub.getAttribute('data-sold'), 10) || 0) + soldLocal;
          sub.textContent = sold > 0 ? 'Dont ' + sold + ' déjà vendue' + (sold > 1 ? 's' : '') : total > 0 ? 'Toutes encore disponibles' : 'Touche le cœur d’une pièce';
        }
      });
      renderSeen();
    });
  }

  function renderSeen() {
    var wraps = document.querySelectorAll('[data-p360-seen-wrap]');
    if (!wraps.length) return;
    var favs = readList(FAV_KEY);
    var seen = readList(SEEN_KEY).filter(function (h) { return favs.indexOf(h) === -1; }).slice(0, 8);
    Promise.all(seen.map(getProduct)).then(function (list) {
      var items = list.filter(Boolean);
      wraps.forEach(function (wrap) {
        var box = wrap.querySelector('[data-p360-seen-list]');
        box.textContent = '';
        items.forEach(function (p) {
          box.appendChild(favCard(p, false));
        });
        wrap.hidden = items.length === 0;
      });
    });
  }

  function toggleFav(handle) {
    var favs = readList(FAV_KEY);
    var i = favs.indexOf(handle);
    if (i > -1) {
      favs.splice(i, 1);
      toast('Retirée de tes favoris.');
    } else {
      favs.unshift(handle);
      toast('Ajoutée à tes favoris. Tu la retrouves dans Mon compte.');
    }
    writeList(FAV_KEY, favs);
    syncHearts();
    renderFavs();
  }

  function noteSeen() {
    var pdp = document.querySelector('.p360-pdp[data-p360-seen]');
    if (!pdp) return;
    var h = pdp.getAttribute('data-p360-seen');
    var seen = readList(SEEN_KEY).filter(function (x) { return x !== h; });
    seen.unshift(h);
    writeList(SEEN_KEY, seen.slice(0, 12));
  }

  // Cœur sur les cartes produit du thème (collections, accueil, recherche), ajouté sans toucher card-product.liquid
  function addCardHearts() {
    document.querySelectorAll('.product-card-wrapper:not([data-p360-h])').forEach(function (card) {
      card.setAttribute('data-p360-h', '');
      if (card.closest('.p360')) return;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var m = (link.pathname.split('/products/')[1] || '').match(/^([a-z0-9-]+)/);
      if (!m) return;
      // Dans .card (et pas .card__inner) pour passer au-dessus du lien qui couvre toute la carte
      var holder = card.querySelector('.card') || card;
      var b = el('button', 'p360-heart p360-heart--card');
      b.type = 'button';
      b.setAttribute('data-p360-fav', m[1]);
      b.setAttribute('aria-label', 'Garder ' + (link.textContent || '').trim() + ' dans mes favoris');
      b.setAttribute('aria-pressed', readList(FAV_KEY).indexOf(m[1]) > -1 ? 'true' : 'false');
      b.innerHTML = HEART;
      holder.appendChild(b);
    });
  }

  var heartTimer = null;
  function watchCards() {
    addCardHearts();
    if (!window.MutationObserver) return;
    new MutationObserver(function () {
      clearTimeout(heartTimer);
      heartTimer = setTimeout(addCardHearts, 250);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function openTab(hub, name, focus) {
    if (TABS.indexOf(name) === -1) return false;
    // Onglet absent de ce compte (ex. « Pano Points » quand le programme n'est pas en ligne) : on ne touche à rien.
    if (!hub.querySelector('[data-p360-panel="' + name + '"]')) return false;
    hub.querySelectorAll('[role="tab"][data-p360-tab]').forEach(function (t) {
      var on = t.getAttribute('data-p360-tab') === name;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      if (on && focus) t.focus();
      // Sur mobile, la barre d'onglets défile : on y montre l'onglet ouvert
      var list = t.parentNode;
      if (on && list && list.scrollWidth > list.clientWidth) {
        list.scrollLeft += t.getBoundingClientRect().left - list.getBoundingClientRect().left - 24;
      }
    });
    hub.querySelectorAll('[data-p360-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-p360-panel') !== name;
      if (!panel.hidden) initGames(panel);
    });
    return true;
  }

  function openTabEverywhere(name) {
    var opened = false;
    document.querySelectorAll('[data-p360-tabs]').forEach(function (hub) {
      if (openTab(hub, name, false)) opened = true;
    });
    if (opened && window.history && history.replaceState) {
      history.replaceState(null, '', name === 'accueil' ? location.pathname + location.search : '#' + name);
    }
  }

  function initTabs() {
    var hubs = document.querySelectorAll('[data-p360-tabs]');
    if (!hubs.length) return;
    var fromHash = (location.hash || '').replace('#', '');
    // Retour du formulaire « Recevoir la lettre » (Shopify ajoute ?customer_posted=true)
    if (/[?&]customer_posted=true/.test(location.search)) fromHash = 'lettre';
    if (TABS.indexOf(fromHash) > -1) {
      hubs.forEach(function (hub) {
        openTab(hub, fromHash, false);
      });
    }
    // Lien vers un onglet depuis la même page (ex. « Panorama 360 » du menu sur /?view=compte#points)
    window.addEventListener('hashchange', function () {
      var name = (location.hash || '').replace('#', '');
      if (TABS.indexOf(name) > -1) openTabEverywhere(name);
    });
    hubs.forEach(function (hub) {
      var list = hub.querySelector('[role="tablist"]');
      if (!list) return;
      var current = list.querySelector('[aria-selected="true"]');
      if (current && list.scrollWidth > list.clientWidth) {
        list.scrollLeft += current.getBoundingClientRect().left - list.getBoundingClientRect().left - 24;
      }
      list.addEventListener('keydown', function (event) {
        var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
        var i = tabs.indexOf(document.activeElement);
        if (i === -1) return;
        var next = null;
        if (event.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        else if (event.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (event.key === 'Home') next = tabs[0];
        else if (event.key === 'End') next = tabs[tabs.length - 1];
        if (!next) return;
        event.preventDefault();
        openTabEverywhere(next.getAttribute('data-p360-tab'));
        next.focus();
      });
    });
  }

  function initPrefs() {
    document.querySelectorAll('[data-p360-prefs]').forEach(function (box) {
      var key = box.getAttribute('data-p360-prefs');
      box.querySelectorAll('[data-p360-pref]').forEach(function (input) {
        var id = 'p360-pref-' + key + '-' + input.getAttribute('data-p360-pref');
        var saved = load(id);
        if (saved !== null) {
          if (input.type === 'checkbox') input.checked = saved === '1';
          else input.value = saved;
        }
        input.addEventListener('change', function () {
          store(id, input.type === 'checkbox' ? (input.checked ? '1' : '0') : input.value);
          toast('Enregistré. Maquette : gardé sur cet appareil.');
        });
      });
    });
  }

  function initAccount() {
    noteSeen();
    watchCards();
    syncHearts();
    initTabs();
    initPrefs();
    renderFavs();
  }

  function start() {
    initAccount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-p360-tab], [data-p360-fav]');
    if (!target) return;

    if (target.hasAttribute('data-p360-tab')) {
      openTabEverywhere(target.getAttribute('data-p360-tab'));
      // Ramène le haut de l'onglet ouvert sous la barre d'onglets (collée en haut de l'écran au défilement)
      var hub = target.closest('[data-p360-tabs]');
      var bar = hub && hub.querySelector('[role="tablist"]');
      var panel = hub && hub.querySelector('[data-p360-panel]:not([hidden])');
      if (bar && panel) {
        var offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
        var barBottom = offset + bar.offsetHeight;
        var top = panel.getBoundingClientRect().top;
        if (top < barBottom || (target.getAttribute('role') !== 'tab' && top > window.innerHeight * 0.6)) {
          window.scrollTo({ top: top + window.pageYOffset - barBottom, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      }
    } else {
      event.preventDefault();
      event.stopPropagation();
      toggleFav(target.getAttribute('data-p360-fav'));
    }
  });
})();
